import DinhChiView from './DinhChiView.jsx';

export {
  DinhChiView
}


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-dinh-chi/index.js